import { render, staticRenderFns } from "./List.vue?vue&type=template&id=21c65f46&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c65f46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21c65f46')) {
      api.createRecord('21c65f46', component.options)
    } else {
      api.reload('21c65f46', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=21c65f46&scoped=true&", function () {
      api.rerender('21c65f46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/result/List.vue"
export default component.exports